import { PRODUCTS } from '@/app/lib/constants'
import { CAT_ANALYTICS } from '@/app/modules/shared/lib/cookieConsent'

const GTM_CONTAINER_ID = import.meta.env.VITE_PUBLIC_GTM_CONTAINER_ID

// Only Mydra AI visits are tracked: ISA is management-only and the marketplace
// is being removed. The script stays blocked (text/plain) until analytics
// consent is given; it must be added before CookieConsent.run() picks it up.
export const loadGoogleTagManager = () => {
  const product = new URLSearchParams(window.location.search).get('product')

  if (!GTM_CONTAINER_ID || product !== PRODUCTS.aiBusiness) {
    return
  }

  const script = document.createElement('script')
  script.type = 'text/plain'
  script.setAttribute('data-category', CAT_ANALYTICS)
  script.textContent = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','${GTM_CONTAINER_ID}');`

  document.head.appendChild(script)
}

export const sendSignUpPageViewEvent = () => {
  if (typeof window !== 'undefined') {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: 'sign_up_page_view',
    })
  }
}

export const sendUserSignUpEvent = async (callback?: () => void) => {
  if (typeof window !== 'undefined') {
    window.dataLayer = window.dataLayer || []
    return new Promise<void>((resolve) => {
      const userSignUpEvent = {
        event: 'user_sign_up',
      }

      if (typeof callback === 'function') {
        const timerId = setTimeout(() => {
          callback?.()
          resolve()
        }, 2000)

        window.dataLayer.push({
          ...userSignUpEvent,
          eventCallback: () => {
            clearTimeout(timerId)
            callback?.()
            resolve()
          },
          eventTimeout: 2000,
        })
      } else {
        window.dataLayer.push(userSignUpEvent)
        resolve()
      }
    })
  }
}
